<template>  
<section class="px-4 mx-auto max-w-5xl xl:px-0"> 
    <h3 class="mb-4 text-2xl leading-none text-center lg:mb-8 sm:text-3xl md:text-32 font-ww-bold xl:px-12" v-html="mainHeading">
    </h3>
    <div class="text-base text-left md:text-lg font-ww-regular" v-html="paragraphText">
    </div>
</section>
</template>

<script setup>
defineProps({
  mainHeading: {
    type: String,
    default: 'What\'s More Energy, More Productivity, and a More Vibrant Day Worth to You?'
  },
  paragraphText: {
    type: String,
    default: 'You deserve to live the fullest, best life possible.<br><br>That starts with improving what you put in your body every day.<br><br>Upgrade your mind–and life–with Mindflow.<br><br>Here\'s what it would cost for you to buy all these ingredients separately–in the same clinical dosages that we use in Mindflow:'
  }
})

defineBuilderComponent({
    friendlyName: 'Title With Paragraph Lead',
    canHaveChildren: false,
    inputs: [
        {
            name: 'mainHeading',
            type: 'richText',
            defaultValue: 'What\'s More Energy, More Productivity, and a More Vibrant Day Worth to You?'
        },
        {
            name: 'paragraphText',
            type: 'richText',
            defaultValue: 'You deserve to live the fullest, best life possible.<br><br>That starts with improving what you put in your body every day.<br><br>Upgrade your mind–and life–with Mindflow.<br><br>Here\'s what it would cost for you to buy all these ingredients separately–in the same clinical dosages that we use in Mindflow:'
        }
    ]
})
</script>